// extracted by mini-css-extract-plugin
export default {"Header":"DefaultHeader_Header__mhnx6","HeaderLink":"DefaultHeader_HeaderLink__4GudG"};